// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"WM-z","loadingMedia":"XM-z","reviewsImagesAndVideos":"YM-z","limitHeight":"ZM-z"};